import { Box, Icons, Stack, Text } from "@sembark-travel/ui-base"

export default function WhatsAppInboxIndexPage() {
	return (
		<Box
			height="full"
			display="flex"
			alignItems="center"
			justifyContent="center"
			padding="4"
		>
			<Stack gap="2" alignItems="center">
				<Text color="muted" fontSize="3xl">
					<Icons.Chat />
				</Text>
				<Text color="muted">Select a conversation to open it here.</Text>
			</Stack>
		</Box>
	)
}
